const CategoryCard = ({ categoryTitle, categoryIcon, handleClick }: any) => {
  return (
    <div
      className='w-20 text-center p-1'
      onClick={handleClick}
    >
      <div>
        <img
          src={categoryIcon}
          alt={`${categoryTitle} thumb`}
          className='w-10 mx-auto my-2 rounded'
        />
      </div>
      <div className='text-xs'>{categoryTitle}</div>
    </div>
  );
};

export default CategoryCard;
